import { render, staticRenderFns } from "./BtnConcepto.vue?vue&type=template&id=9ff7e628&"
import script from "./BtnConcepto.vue?vue&type=script&lang=js&"
export * from "./BtnConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports